{
  "table": {
    "titleJ": "GLIDER FLIGHTS",
    "titleM": "POWERED FLIGHTS"
  },
  "modal": {
    "zapis": "Record edited by:",
    "namen": "Purpose:",
    "naloga": "Task:",
    "reg": "Registration:",
    "pilot": "Pilot:",
    "krajV": "Takeoff location:",
    "krajP": "Landing location:",
    "vZraku": "in the air:",
    "vizuelno": "visual:",
    "stPristankov": "Number of landings:",
    "opomba": "Note:",
    "datumU": "Edit date:",
    "regV": "Tow aircraft registration:",
    "instruktor": "Instructor:",
    "poletanje": "Takeoff:",
    "casO": "Release time:",
    "pristanek": "Landing:",
    "trajanje": "Duration:",
    "vleka": "Tow:",
    "casV": "Tow time:"
  }
}